import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { ProfitChart, ProfitChartService } from './profit-chart.service';
import { OrdersChartService } from '../mock/orders-chart.service';
import { OrdersChart } from '../data/orders-chart';

export class OrderProfitChartSummary {
  title: string;
  value: number;
}

@Injectable()
export class OrdersProfitChartService {

  private summary = [
    {
      title: 'Max Daily Capacity',
      value: 500,
    },
    {
      title: 'Average Daily Output',
      value: 350,
    },
    {
      title: 'Minimum Daily Output',
      value: 200,
    },

  ];

  constructor(private ordersChartService: OrdersChartService,
    private profitChartService: ProfitChartService) {
  }

  getOrderProfitChartSummary(): Observable<OrderProfitChartSummary[]> {
    return observableOf(this.summary);
  }

  getOrdersChartData(period: string): Observable<OrdersChart> {
    return observableOf(this.ordersChartService.getOrdersChartData(period));
  }

  getProfitChartData(period: string): Observable<ProfitChart> {
    return observableOf(this.profitChartService.getProfitChartData(period));
  }
}
